// extracted by css-extract-rspack-plugin
export default {"content":"tEam_oUS478OZQbi","fullViewportContent":"epib2fhIDS4NVKOI","scrollableFullViewportContent":"Wh4MUz2L2hg2YpHs"};